export default {"src":"/gallery/_next/static/media/metamask.715b3f2a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};